import React, { useCallback, useState } from "react";
import { useParams } from "react-router-dom";
import { JwtManager } from "../components/shared/JwtManager";
import config from "../config";
import { Alert, AlertColor, Box, Button, CircularProgress } from "@mui/material";
import { useConvertToPdf } from "../components/Word/useConvertToPdf";
import { useTranslation } from "react-i18next";
import { Snackbar } from "../components/shared/Snackbar";

export function Word() {
  const { t } = useTranslation();

  const { fileId, customerId, companyId, siteId } = useParams<{
    fileId: string;
    customerId: string;
    companyId: string;
    siteId: string;
  }>();
  let wopiSrc = `${config.apiGateway.UTP2_API}/api/Files/wopi/files/${Number(fileId)}/customer/${Number(customerId)}/company/${Number(companyId)}/site/${Number(siteId)}`;
  let encodedWopiSrc = encodeURIComponent(wopiSrc);
  let headerHeight = "100px";

  const tokenManager = new JwtManager({});
  const getToken = () => tokenManager.getToken();
  const accessToken = getToken();

  const url = `${config.apiGateway.COLLABORA_API}/browser/9831402/cool.html?WOPISrc=${encodedWopiSrc}&access_token=${accessToken}`;

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarText, setSnackbarText] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState<AlertColor>("success");

  const convertToPdf = useConvertToPdf({
    onSuccess: onConvertedToPdfSuccess,
    onError: onConvertedToPdfError,
  });

  function onConvertedToPdfSuccess() {
    setSnackbarText(t("reports.convertToPdfSuccess"));
    setSnackbarSeverity("success");
    setShowSnackbar(true);
  }

  function onConvertedToPdfError() {
    setSnackbarText(t("reports.convertToPdfError"));
    setSnackbarSeverity("error");
    setShowSnackbar(true);
  }

  const handleSnackbarClose = useCallback(() => {
    setShowSnackbar(false);
  }, []);

  const handleConvertToPdf = () => {
    if (url != null) {
      convertToPdf.mutate(Number(fileId));
    }
  };

  const snackbarTimeout = () => {
    setTimeout(() => {
      setShowSnackbar(false);
    }, 10000);
  };

  return (
    <React.Fragment>
      {convertToPdf.isLoading ? (
        <div
          style={{
            height: `calc(100vh - ${headerHeight})`,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box>
            <Button type="submit" variant="contained" color="primary" onClick={handleConvertToPdf} disabled={true}>
              Convert to PDF
            </Button>
          </Box>
          <br />
          <div className="d-flex justify-content-center">
            <CircularProgress size={65} />
          </div>
        </div>
      ) : (
        <div
          style={{
            height: `calc(100vh - ${headerHeight})`,
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Box>
            <Button type="submit" variant="contained" color="primary" onClick={handleConvertToPdf}>
              Convert to PDF
            </Button>
          </Box>
          <br />
          <iframe src={url} style={{ flexGrow: 1 }} title={"collabora"} onLoad={snackbarTimeout} />
        </div>
      )}

      <Snackbar open={showSnackbar} onClose={handleSnackbarClose}>
        <Alert severity={snackbarSeverity} variant="filled">
          {snackbarText}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
}
